import { DatePicker, DatePickerProps, Typography } from 'antd'
import dayjs from 'dayjs'
import React, { useMemo } from 'react'
import { FieldError } from 'react-hook-form'
import { useSelector } from 'react-redux'
import ErrorText from 'src/app/shared/components/common/error-text'
import { FORMAT_DATE } from 'src/app/shared/constants/app.constants'
import { getUserProfile } from 'src/app/store/auth'
import { getDefaultTimeZone } from 'src/app/store/masterSetup'
import { colorPrimary } from 'src/app/themes/primaryThemeDefault'
import './index.scss'

const CustomDatePicker: React.FC<
  Omit<DatePickerProps, 'value'> & {
    label?: string
    required?: boolean
    error?: FieldError
    value: any
    containerStyle?: React.CSSProperties
    showToday?: boolean
    minDate?: dayjs.Dayjs
  }
> = (props) => {
  const { label, required, size = 'large', error, style, containerStyle, inputReadOnly = true, ...etc } = props
  const defaultTimeZone = useSelector(getDefaultTimeZone)
  const userProfile = useSelector(getUserProfile)

  const minDateAsDayjs = useMemo(() => {
    if (props.minDate) {
      return props.minDate.tz(userProfile?.client?.timeZoneId ?? defaultTimeZone?.code)
    }
    return undefined
  }, [props.minDate, userProfile, defaultTimeZone])

  const disabled = useMemo(() => {
    return props.disabled
  }, [props.disabled])

  const customDateRender = (current: dayjs.Dayjs) => {
    // in case Bank User todayDate base on ternent timezone
    // in case Client User todayDate base on client timezone
    const todayDate = dayjs().tz(userProfile?.client?.timeZoneId ?? defaultTimeZone?.code)
    return (
      <div
        className='ant-picker-cell-inner'
        style={
          current.format('DD/MM/YYYY') === todayDate.format('DD/MM/YYYY')
            ? { border: `1px solid ${colorPrimary}`, borderRadius: '4px' }
            : {}
        }
      >
        {current.date()}
      </div>
    )
  }

  return (
    <div
      className='custom-date-picker'
      style={{
        flex: 1,
        display: 'block',
        ...containerStyle,
      }}
    >
      <Typography
        style={{ textAlign: 'left', fontSize: '14px', fontWeight: 700 }}
        className={`${required ? 'required' : ''} custom-select-label`}
      >
        {label}
      </Typography>
      <DatePicker
        size={size}
        minDate={minDateAsDayjs}
        style={{
          marginBottom: error ? 4 : 0,
          marginTop: 4,
          borderRadius: 12,
          width: '100%',
          ...style,
        }}
        status={!!error ? 'error' : ''}
        format={FORMAT_DATE}
        inputReadOnly={inputReadOnly}
        dateRender={customDateRender}
        disabled={disabled}
        {...etc}
      />
      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomDatePicker
